import { Component, OnInit } from '@angular/core';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ProductService } from 'src/app/services/product.service';
import { ToastrService } from 'ngx-toastr';
import { DynamicReportsService } from 'src/app/services/dynamic-reports.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseObject } from 'src/app/models/response-object.model';

@Component({
  selector: 'app-client-sales',
  templateUrl: './client-sales.component.html',
  styleUrls: ['./client-sales.component.scss']
})
export class ClientSalesComponent implements OnInit {
  startDate: string;
  endDate: string;
  filterProducts = [];
  products = [];
  clients = [];
  inputs = {
    product: {
      value: '',
      verified: false,
      required: false,
      message: '-',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null
    }
  };
  timeout = null;

  pagination = new PaginationModel(0, 5, 0, 0, [], []);
  filteredResults = [];

  totalUnidades = 0;
  totalVenta = 0;
  totalCosto = 0;
  totalUtilidad = 0;
  totalMargen = 0;

  sortColumn: string = '';
  sortDirection: string = '';

  constructor(
    private productService: ProductService,
    private toastService: ToastrService,
    private dynamicReportsService: DynamicReportsService
  ) {}

  ngOnInit(): void {
    this.getProducts();
  }

  getProducts() {
    this.productService.getProductsPurchase('').subscribe(
      (response) => {
        this.products = Object(response)['data'].map(p => ({ ...p, selected: false }));
        this.filterProducts = this.products;
      },
      (error) => {
        console.error(error.error.message);
      }
    );
  }

  handleInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'product') {
      clearTimeout(this.timeout);
      this.inputs.product.class = "typing";
      this.timeout = setTimeout(() => {
        this.filterProducts = this.products.filter((product) =>
          product.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          product.id == parseInt(inputValue)
        );
        if (this.filterProducts.length === 0) {
          this.changeStatusInput(null, null, 0, 'product');
        } else {
          this.inputs.product.class = "bx bx-list-check";
        }
      }, 500);
    }
  }

  verifiedInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'product') {
      let temp = this.products.filter((product) =>
        product.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        product.id == parseInt(inputValue)
      );
      if (temp.length === 1) {
        this.changeStatusInput(temp[0], (temp[0].barCode ? temp[0].barCode + ' - ' : '') + temp[0].name, 1, 'product');
      } else {
        this.changeStatusInput(null, null, 0, 'product');
      }
    }
  }

  changeStatusInput(selected: any, newValue: string, status: number, type: string) {
    let tempInput = this.inputs[type];
    tempInput.verified = status === 1;
    if (status === 1) {
      tempInput.data = selected;
      tempInput.value = newValue;
      tempInput.color = "success";
      tempInput.class = 'fa-check';
    } else {
      tempInput.data = null;
      tempInput.color = 'danger';
      tempInput.class = (status === 0) ? 'fa-xmark' : 'fa-asterisk';
    }
  }

  executeSearch() {
    const selectedProducts = this.products.filter(p => p.selected);
    const selectedIds = selectedProducts.map(p => p.id);

    if (!this.validateInputs(selectedIds)) return;

    const request = {
      startDate: this.startDate,
      endDate: this.endDate,
      productIds: selectedIds
    };

    this.dynamicReportsService.getClientSalesReport(request).subscribe({
      next: (response: ResponseObject) => {
        this.clients = response.data;
        this.pagination.total = this.clients;
        this.resetPagination();
        this.toastService.success('Reporte generado correctamente');
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener el reporte');
        console.error(error);
      }
    });
  }


  

  // executeSearch() {
  //   // Mock data
  //   this.clients = [
  //     {
  //       name: 'Client A',
  //       expanded: false,
  //       totalUnits: 1500,
  //       totalSales: 50000,
  //       totalCost: 42000,
  //       totalProfit: 8000,
  //       totalMargin: 0.16,
  //       warehouses: [
  //         {
  //           name: 'Warehouse 1',
  //           expanded: false,
  //           totalUnits: 800,
  //           totalSales: 30000,
  //           totalCost: 25000,
  //           totalProfit: 5000,
  //           totalMargin: 0.17,
  //           products: [
  //             {
  //               name: 'Product 1',
  //               units: 500,
  //               sales: 20000,
  //               cost: 17000,
  //               profit: 3000,
  //               margin: 0.15
  //             },
  //             {
  //               name: 'Product 2',
  //               units: 300,
  //               sales: 10000,
  //               cost: 8000,
  //               profit: 2000,
  //               margin: 0.20
  //             }
  //           ]
  //         },
  //         {
  //           name: 'Warehouse 2',
  //           expanded: false,
  //           totalUnits: 700,
  //           totalSales: 20000,
  //           totalCost: 17000,
  //           totalProfit: 3000,
  //           totalMargin: 0.15,
  //           products: [
  //             {
  //               name: 'Product 3',
  //               units: 400,
  //               sales: 12000,
  //               cost: 10000,
  //               profit: 2000,
  //               margin: 0.17
  //             },
  //             {
  //               name: 'Product 4',
  //               units: 300,
  //               sales: 8000,
  //               cost: 7000,
  //               profit: 1000,
  //               margin: 0.13
  //             }
  //           ]
  //         }
  //       ]
  //     },
  //     {
  //       name: 'Client B',
  //       expanded: false,
  //       totalUnits: 1000,
  //       totalSales: 40000,
  //       totalCost: 34000,
  //       totalProfit: 6000,
  //       totalMargin: 0.15,
  //       warehouses: [
  //         {
  //           name: 'Warehouse 3',
  //           expanded: false,
  //           totalUnits: 1000,
  //           totalSales: 40000,
  //           totalCost: 34000,
  //           totalProfit: 6000,
  //           totalMargin: 0.15,
  //           products: [
  //             {
  //               name: 'Product 5',
  //               units: 1000,
  //               sales: 40000,
  //               cost: 34000,
  //               profit: 6000,
  //               margin: 0.15
  //             }
  //           ]
  //         }
  //       ]
  //     }
  //   ];
  //   this.pagination.total = this.clients;
  //   this.resetPagination();

  //   const selectedProducts = this.products.filter(p => p.selected);
  //   const selectedIds = selectedProducts.map(p => p.id);
  //   console.log("Productos seleccionados:", selectedIds);
  //   console.log("Fecha inicio", this.startDate);
  //   console.log("Fecha final", this.endDate);
  //   if(this.validateInputs(selectedIds)){
  //     // realizar la busqueda
  //     this.toastService.info("Busqueda realizada");
  //   }
  // }

  validateInputs(selectedIds:any){
    if(selectedIds.length <= 0){
      this.toastService.error("Debe seleccionar almenos un producto para realizar la busqueda");
      return false;
    }
    if(this.startDate == null || this.startDate == undefined){
      this.toastService.error("Debe seleccionar la fecha de inicio para realizar la busqueda");
      return false;
    }
    if(this.endDate == null || this.endDate == undefined){
      this.toastService.error("Debe seleccionar la fecha de fin para realizar la busqueda");
      return false;
    }
    return true;
  }

  toggleClient(client: any) {
    client.expanded = !client.expanded;
  }

  toggleWarehouse(warehouse: any, event: MouseEvent) {
    event.stopPropagation();
    warehouse.expanded = !warehouse.expanded;
  }

  resetPagination() {
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.lastElement = this.pagination.pageSize;
    this.pagination.filter = this.pagination.total.slice(
      this.pagination.startElement,
      this.pagination.lastElement
    );
    this.filteredResults = this.pagination.filter;
    this.calculateTotals();
  }

  changePage(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.pagination.startElement = pageIndex * this.pagination.pageSize;
    this.pagination.lastElement = this.pagination.startElement + this.pagination.pageSize;
    this.pagination.filter = this.pagination.total.slice(
      this.pagination.startElement,
      this.pagination.lastElement
    );
    this.filteredResults = this.pagination.filter;
    this.calculateTotals();
  }

  calculateTotals() {
    this.totalUnidades = this.filteredResults.reduce((sum, item) => sum + item.totalUnits, 0);
    this.totalVenta = this.filteredResults.reduce((sum, item) => sum + item.totalSales, 0);
    this.totalCosto = this.filteredResults.reduce((sum, item) => sum + item.totalCost, 0);
    this.totalUtilidad = this.filteredResults.reduce((sum, item) => sum + item.totalProfit, 0);
    this.totalMargen = this.totalVenta > 0 ? this.totalUtilidad / this.totalVenta : 0;
  }

  sortByColumn(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    console.log("Se ordenara la columna");
    console.log(column);

    this.filteredResults.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];
      console.log("Valor A: ", valueA);
      console.log("Valor B: ", valueB);
      
      if (typeof valueA === 'string') {
        valueA = valueA.toLowerCase();
        valueB = valueB.toLowerCase();
      }

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

}
